import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheck,
    faCircle,
    faChevronLeft,
    faChevronDown,
    faChevronUp,
    faInfoCircle,
    faUser,
    faBars,
    faQuestionCircle,
    faExclamationCircle,
    faMinusCircle,
    faCheckCircle,
    faUserPlus,
} from '@fortawesome/free-solid-svg-icons'
import { faTruck, faExclamationTriangle, faCreditCardFront, faMoneyCheck, faPencil, faIdCard, faCalendarCheck, faSearch, faArrowLeft, faTimes, faLocation, faArrowToRight, faPlus, faTrash, faUserCheck, faUserTimes, faEnvelopeOpen } from '@fortawesome/pro-regular-svg-icons'
import { faPaypal, faCcVisa, faCcAmex, faCcMastercard, faCcDinersClub, faCcDiscover, faCcJcb } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faCheck,
    faCircle, faInfoCircle, faQuestionCircle, faMinusCircle, faExclamationCircle,
    faChevronLeft, faChevronDown, faChevronUp,
    faTruck,
    faUser, faUserPlus,
    faLocation,
    faArrowToRight,
    faBars,
    faExclamationTriangle,
    faPencil,
    faPaypal, faCheckCircle, faCcDinersClub, faCcDiscover, faCcJcb, faCcAmex, faCcVisa, faCcMastercard, faCreditCardFront, faMoneyCheck,
    faIdCard,
    faCalendarCheck,
    faSearch,
    faArrowLeft,
    faTimes,
    faPlus,
    faTrash,
    faUserCheck,
    faUserTimes,
    faEnvelopeOpen
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
